import { Button, Dialog, DialogActions, DialogTitle } from '@mui/material';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import env from '../../config/env';

function OpenMapRouteDialog({ open, onClose }) {
  const { orderMap } = useSelector((store) => store.orders);
  const { t } = useTranslation(['system', 'button']);

  const handleOpenExternalMap = () => {
    onClose();
    const { latitude, longitude } = orderMap;

    const mapsUrl = `${env.MAP_ROUTE_URL}/?api=1&destination=${latitude},${longitude}`;

    window.location.href = mapsUrl;
  };

  return (
    <Dialog open={open}>
      <DialogTitle>{t('DISPLAY_ROUTE', { ns: 'system' })}</DialogTitle>

      <DialogActions>
        <Button color="error" onClick={onClose}>
          {t('cancel', { ns: 'button' })}
        </Button>

        <Button onClick={handleOpenExternalMap}>
          {t('open', { ns: 'button' })}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default OpenMapRouteDialog;
